export default __webpack_public_path__ + "static/media/icn-trash-bin-red.8b768786.svg";